import styled from '@emotion/styled';

const CellContainer = styled.div`
  border: 1px solid black;
  width: 100%;
`;

export { CellContainer };
